import { Box, Typography } from '@mui/material';
import StarIcon from '../../../assets/images/icons/star_white.png';
import Business from '../../../assets/images/pages/reward/reward-business.png';
import Everyday from '../../../assets/images/pages/reward/reward-everyday.png';
import Hero from '../../../assets/images/pages/reward/reward-hero.png';
import Lifestyle from '../../../assets/images/pages/reward/reward-lifestyle.png';
import Others from '../../../assets/images/pages/reward/reward-other.png';
import Premium from '../../../assets/images/pages/reward/reward-premium.png';
import Wellness from '../../../assets/images/pages/reward/reward-wellness.png';
import { useRewardStore } from '../../../stores/rewardStore';
import { useUserStore } from '../../../stores/userStore';
import { addCommaToNumber } from '../../../utils/utils';

const RewardCard = () => {
  const companyInfo = useUserStore((state) => state.companyInfo);
  const filters = useRewardStore((state) => state.filters);
  const setFilters = useRewardStore((state) => state.setFilters);

  const point = companyInfo ? addCommaToNumber(companyInfo.accumulated_points) : '0';

  const handleFilterClick = (value) => {
    const clone = [...filters];
    const index = clone.indexOf(value);

    if (index === -1) {
      setFilters([value]);
    } else {
      clone.splice(index, 1);
      setFilters(clone);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '250px',
        background: '#E1000C',
        padding: '10px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        gap: '5px',
        position: 'relative',
      }}
    >
      {/* Images */}
      <Box
        sx={{
          width: '100%',
          maxWidth: '450px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          padding: '10px',
          zIndex: '9',
        }}
      >
        <Box
          component={'img'}
          src={Hero}
          alt="Reward"
          sx={(theme) => ({
            width: '100%',
            maxWidth: '250px',
            display: 'block',
            margin: '0 auto 5px',
            transform: 'translateY(20px)',
            [theme.breakpoints.up('sm')]: {
              maxWidth: '280px',
            },
          })}
        />
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(6, 1fr)',
            gap: '10px',
            alignItems: 'flex-end',
          }}
        >
          <Box
            component={'img'}
            src={Everyday}
            alt="Reward"
            onClick={() => handleFilterClick('Everyday treat & Goodies')}
            sx={{
              width: '100%',
              paddingBottom: '4px',
              cursor: 'pointer',
              borderBottom: filters.includes('Everyday treat & Goodies')
                ? '4px solid white'
                : 'none',
            }}
          />
          <Box
            component={'img'}
            src={Business}
            alt="Reward"
            onClick={() => handleFilterClick('Business Utility')}
            sx={{
              width: '100%',
              paddingBottom: '4px',
              cursor: 'pointer',
              borderBottom: filters.includes('Business Utility') ? '4px solid white' : 'none',
            }}
          />
          <Box
            component={'img'}
            src={Wellness}
            alt="Reward"
            onClick={() => handleFilterClick('Wellness & Vitality')}
            sx={{
              width: '100%',
              paddingBottom: '4px',
              cursor: 'pointer',
              borderBottom: filters.includes('Wellness & Vitality') ? '4px solid white' : 'none',
            }}
          />
          <Box
            component={'img'}
            src={Lifestyle}
            alt="Reward"
            onClick={() => handleFilterClick('Lifestyle & Thank You')}
            sx={{
              width: '100%',
              paddingBottom: '4px',
              cursor: 'pointer',
              borderBottom: filters.includes('Lifestyle & Thank You') ? '4px solid white' : 'none',
            }}
          />
          <Box
            component={'img'}
            src={Premium}
            alt="Reward"
            onClick={() => handleFilterClick('Premium Reward')}
            sx={{
              width: '100%',
              paddingBottom: '4px',
              cursor: 'pointer',
              borderBottom: filters.includes('Premium Reward') ? '4px solid white' : 'none',
            }}
          />
          <Box
            component={'img'}
            src={Others}
            alt="Reward"
            onClick={() => handleFilterClick('Others')}
            sx={{
              width: '100%',
              paddingBottom: '4px',
              cursor: 'pointer',
              borderBottom: filters.includes('Others') ? '4px solid white' : 'none',
            }}
          />
        </Box>
      </Box>

      {/* Title */}
      <Box sx={{ position: 'relative', zIndex: '10', height: 'fit-content' }}>
        <Typography
          component={'h1'}
          sx={{
            fontSize: '2.2rem',
            lineHeight: '2rem',
            fontWeight: '500',
            color: 'white',
            marginBottom: '5px',
          }}
        >
          Reward
        </Typography>
      </Box>

      {/* Point */}
      <Box
        sx={{
          position: 'relative',
          zIndex: '10',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          height: 'fit-content',
        }}
      >
        <Typography
          sx={{
            fontSize: '1.5rem',
            lineHeight: '1.5rem',
            fontWeight: '500',
            color: 'white',
            textAlign: 'right',
          }}
        >
          คะแนนสะสม
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '3px' }}>
          <Box component={'img'} src={StarIcon} alt="Star Icon" sx={{ width: '25px' }} />
          <Typography
            sx={{ fontSize: '2rem', lineHeight: '2rem', fontWeight: '500', color: 'white' }}
          >
            {point}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default RewardCard;
